module.exports = __webpack_public_path__ + "static/img/news_tu3.af02eed.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_tu3.png
// module id = KBZL
// module chunks = 0